import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import TagManager from "react-gtm-module";
import { AuthReducer } from "./reducers/AuthReducer/AuthReducer";

// Initialize Google Tag Manager
const tagManagerArgs = {
  gtmId: "GTM-W689WL82",
};

TagManager.initialize(tagManagerArgs);

const queryClient = new QueryClient();

const store = configureStore({
  reducer: {
    auth: AuthReducer,
  },
});

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <App />
        </Provider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
